<!-- src/components/tournament-manage/tournament-manage.component.html -->
<div class="tournaments-page manage-page">
  <ng-container *ngIf="!loading && tournament">
    <header class="page-header">
      <h1>{{ tournament.name }}</h1>
      <a [routerLink]="['/tournaments', tournament.id]" class="link-btn">View public page</a>
    </header>

    <div class="manage-stats">
      <div class="stat"><span class="stat-label">Status</span><span class="stat-value" data-testid="status">{{ tournament.status }}</span></div>
      <div class="stat"><span class="stat-label">Teams</span><span class="stat-value">{{ tournament.registered_teams_count }} / {{ tournament.max_teams }}</span></div>
    </div>

    <div class="actions">
      <button type="button" *ngIf="canDraw" data-testid="draw-btn" [disabled]="submitting" (click)="generateDraw()">
        Generate draw
      </button>
      <button type="button" *ngIf="!canDraw && tournament.status === TournamentStatus.Open" disabled data-testid="draw-waiting">
        Registration still open
      </button>
      <button type="button" *ngIf="canCancel" class="danger" data-testid="cancel-btn" [disabled]="submitting" (click)="cancelTournament()">
        Cancel tournament
      </button>
    </div>

    <p class="action-error" *ngIf="error" data-testid="manage-error">{{ error }}</p>

    <section *ngIf="bracket" class="bracket-section">
      <h2>Bracket</h2>
      <app-tournament-bracket [bracket]="bracket" [organizer]="true" (matchSelected)="openResult($event)"></app-tournament-bracket>
      <p class="hint">Tap a match with both teams to enter the result.</p>
    </section>
  </ng-container>

  <!-- Result entry modal -->
  <div class="modal-backdrop" *ngIf="activeMatch" data-testid="result-modal" (click)="closeResult()">
    <div class="modal" (click)="$event.stopPropagation()">
      <h3>Enter result</h3>

      <label class="radio-row">
        <input type="radio" name="winner" [value]="activeMatch.team_a_id" [(ngModel)]="winnerTeamId" />
        {{ activeMatch.team_a_name }}
      </label>
      <label class="radio-row">
        <input type="radio" name="winner" [value]="activeMatch.team_b_id" [(ngModel)]="winnerTeamId" />
        {{ activeMatch.team_b_name }}
      </label>

      <label class="walkover-row">
        <input type="checkbox" [(ngModel)]="isWalkover" /> Walkover (no scores)
      </label>

      <div class="sets" *ngIf="!isWalkover">
        <div class="set-row" *ngFor="let s of sets; let i = index">
          <span>Set {{ i + 1 }}</span>
          <input type="number" min="0" [(ngModel)]="s.a" [name]="'sa' + i" placeholder="A" />
          <input type="number" min="0" [(ngModel)]="s.b" [name]="'sb' + i" placeholder="B" />
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="link-btn" (click)="closeResult()">Cancel</button>
        <button type="button" data-testid="result-submit" [disabled]="submitting || winnerTeamId == null" (click)="submitResult()">Save result</button>
      </div>
    </div>
  </div>
</div>
